import { Box, styled } from '@mui/material';

export const StyledIcon = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    width: 34px;
    font-size: 15px;
    border-radius: 5px;
`;
